import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack, Text } from 'braid-design-system';
import { useEffect } from 'react';

import { logError } from 'src/modules/error-logger/browserLog';

import translations from './.vocab';
import { Tools } from './Tools';

interface Props {
  error?: Error | Record<string, unknown>;
  type?: string;
  message?: string;
  applicationCorrelationId?: string;
  jobId?: string;
}

export const SomethingWentWrong = ({
  error,
  type = '',
  message = '',
  applicationCorrelationId = '',
  jobId = '',
}: Props) => {
  const { t } = useTranslations(translations);

  useEffect(() => {
    if (error) {
      logError(
        {
          ...error,
          type,
          message,
        },
        { error, jobId, applicationCorrelationId },
      );
    }
  }, [error, applicationCorrelationId, jobId, message, type]);

  return (
    <Box
      textAlign="center"
      padding={{
        mobile: 'none',
        tablet: 'large',
        desktop: 'large',
        wide: 'large',
      }}
      marginTop="large"
      marginBottom="large"
      data={{ testid: 'full-page-error' }}
    >
      <Stack space="large">
        <Tools />
        <Stack space="small">
          <Heading level="4">{t("We're working on it.")}</Heading>
          <Text>{t("We're fixing this as fast as we can.")}</Text>
          <Text>{t('Try refreshing the page or check back later.')}</Text>
        </Stack>
      </Stack>
    </Box>
  );
};
